import { Component, HostListener } from '@angular/core';
// do not remove this line, it is used to initialize the master data after login or refresh
//import {ProjectDataService} from './global-services/project-data.service';
//import {AppDbDexieService} from "./global-services/app-db-dexie.service";
import { Router, RouterOutlet } from '@angular/router';
import { ProjectDataService } from './global-services/project-data.service';
import { AppDbDexieService } from './global-services/app-db-dexie.service';
import { QuicklinkModule } from 'ngx-quicklink';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [QuicklinkModule, RouterOutlet],
})
export class AppComponent {
  constructor(
    private router: Router,
    // do not remove the db,thumbnailGenerator line, it is used to initialize
    private db: AppDbDexieService,
    private projectDataService: ProjectDataService
  ) {
    this.projectDataService.initServiceWorkerEvents();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    console.log(
      'app.component:onPopState:pressed back btn in browser, reloading page...: '
    );
    this.router.navigateByUrl(`${window.location.pathname}`, {
      onSameUrlNavigation: 'reload',
      skipLocationChange: true,
    });
  }
}
